"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // =========================== Motion ===========================

var genRtlStyle = function genRtlStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, "".concat(componentCls, "-rtl"), {
    direction: 'rtl'
  });
};

var _default = genRtlStyle;
exports.default = _default;